import { createFileRoute, redirect } from '@tanstack/react-router';
import { Login } from '@/pages';

/**
 * Login Route
 * Public route for user authentication
 * Redirects authenticated users to dashboard
 */
export const Route = createFileRoute('/_public/login')({
  beforeLoad: async ({ context, search }) => {
    // If already authenticated, redirect to dashboard or the intended destination
    if (!context.auth.isLoading && context.auth.isAuthenticated) {
      const redirectTo = (search as { redirect?: string })?.redirect || '/dashboard';
      throw redirect({
        to: redirectTo,
      });
    }
  },
  component: Login,
});
